import { useQuery } from "@apollo/client";
import { TOGGLEABLE_FEATURE_FLAGS } from "utility/graphQl/query";
import { LearnerFeatureFlag } from "../api/types";

interface ToggleableFeatureFlagsQueryResult {
  toggleableFeatureFlags: LearnerFeatureFlag[];
}

interface UseToggleableFeatureFlagsReturn {
  flags: LearnerFeatureFlag[];
  loading: boolean;
}

// Returns [] unless the caller's token carries the feature-flags:write
// scope, so flag-toggle UI driven by this hook is invisible to everyone else.
export default function useToggleableFeatureFlags(): UseToggleableFeatureFlagsReturn {
  const { data, loading } = useQuery<ToggleableFeatureFlagsQueryResult>(
    TOGGLEABLE_FEATURE_FLAGS,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  return {
    flags: data?.toggleableFeatureFlags ?? [],
    loading,
  };
}
